import mapboxgl from 'mapbox-gl';
import maplibregl from "maplibre-gl";

export default {
    data() {
        return {
            locationMarkers: new Map(),
            clusterMarkers: new Map(),
        }
    },
    methods: {
        addClusterMarker(feature) {
            var self = this;
            const coordinates = feature.geometry.coordinates;
            let bubbleDiv = this.$refs['clusterMarkerTemplate'].cloneNode(true);
            let bubbbleLink = bubbleDiv.querySelector('.bubble_link');
            let countBox = bubbleDiv.querySelector('.count_box');
            bubbbleLink.innerHTML = `<span loading="lazy" class="inline rounded-full bg-cover w-10 h-10 marker-size" style="background-image:url(${feature.properties.marker_image_url});"/></span>`;

            countBox.textContent = feature.properties.point_count;

            bubbleDiv.addEventListener('click', function () {
                self.mySmartMap.flyTo({
                    center: coordinates,
                    zoom: feature.expansion_zoom +1,
                    speed: 1.8
                });
            });

            const el = document.createElement('div');
            el.appendChild(bubbleDiv);

            const marker = self.useMaplibre
            ? new maplibregl.Marker(el).setLngLat(coordinates).addTo(this.mySmartMap)
            : new mapboxgl.Marker(el).setLngLat(coordinates).addTo(this.mySmartMap);

            this.clusterMarkers.set(feature.id, marker);
        },
        addLocationMarker(feature) {
            var self = this;
            let bubbleDiv = this.$refs['locationMarkerTemplate'].cloneNode(true);
            let bubbbleLink = bubbleDiv.querySelector('.bubble_link');
            let stamGroup = bubbleDiv.querySelector('.stamp_group');

            const currentCongestion = feature.properties.current_congestion;
            if (currentCongestion && currentCongestion.level) {
                bubbleDiv.style.cssText = 'display: flex;justify-content: center;';
                let congestionElement = document.querySelector(`#congestion-level-${currentCongestion.level}`);
                congestionElement.querySelector('.title').innerText = currentCongestion.title;
                let currentCongestionTooltip = bubbleDiv.querySelector('#currentCongestionTooltip');
                currentCongestionTooltip.innerHTML = congestionElement.innerHTML;
                currentCongestionTooltip.style.cssText = `display:block; position: absolute;bottom: 100%;white-space: nowrap;`;
            }

            feature.properties.items.forEach((item, index) => {
                let a = document.createElement('a');
                a.classList.add('stamp_link');
                a.setAttribute('href', 'javascript:void(0)');
                a.style.left = -(index * 15) - 6 + 'px';
                a.innerHTML = `<span loading="lazy" class="inline rounded-full bg-cover w-5 h-5" style="background-image:url(${item.image_url});"></span>`;

                stamGroup.appendChild(a);
            });
            bubbbleLink.innerHTML = `<span loading="lazy" class="inline rounded-full bg-cover marker-size" style="background-image:url(${feature.properties.marker_image_url});"></span>`;

            if (feature.properties.marker_style == 'square') {
                bubbleDiv.classList.add('rounded');
                bubbleDiv.querySelector('span').classList.remove('p-1','rounded-full');
                bubbleDiv.querySelector('span').classList.add('rounded');
            } else if (feature.properties.marker_style == 'icon') {
                bubbleDiv.classList.remove('bubble','pin','btn','h-12','w-12','rounded-full');
                bubbleDiv.classList.add('icon-marker','bg-base-100','h-7','w-7','rounded');
                bubbleDiv.querySelector('span').classList.remove('w-10','h-10');
                bubbleDiv.querySelector('span').classList.add('rounded','w-6','h-6','icon-size');
                stamGroup.style.display = 'none';
            } else if (feature.properties.marker_style == 'custom') {
                bubbleDiv.classList.remove('bubble','pin','btn','h-12','w-12','bg-primary');
                bubbleDiv.classList.add('custom-marker','h-14','w-14');
                bubbleDiv.querySelector('span').classList.remove('rounded-full');
                stamGroup.style.display = 'none';
            }
            bubbleDiv.classList.add('marker-box');
            const el = document.createElement('div');
            el.id = 'spot-' + feature.properties.id;
            el.appendChild(bubbleDiv);

            if (this.mapData.show_tooltip) {
                const tooltipEl = document.createElement('div');
                tooltipEl.id = 'tooltip-' + feature.properties.id;
                tooltipEl.classList.add("tooltip-box", "absolute", "inset-0", "flex", "items-center");
                if (feature.properties.marker_style == 'custom') {
                    tooltipEl.innerHTML = `
                        <div class="tooltip-marker bg-primary h-2 w-2 rounded-full"></div>
                        <div class="text-xs font-bold custom-tooltip-ttl">${feature.properties.title}</div>
                    `;
                } else {
                    tooltipEl.innerHTML = `
                    <div class="tooltip-marker bg-primary h-2 w-2 rounded-full"></div>
                    <div class="text-xs font-bold tooltip-ttl">${feature.properties.title}</div>
                    `;
                } 
                el.appendChild(tooltipEl);
                self.handleTooltipZoomRange(el);
            } else {
                bubbleDiv.addEventListener('mousemove', function (e) {
                    let tooltip = {
                        id: feature.properties.id,
                        title: feature.properties.title,
                        // category_title: feature.properties.category.title,
                        top: e.y + 20 + 'px',
                        left: e.x + 20 + 'px'
                    };
                    self.updateTooltip(tooltip);
                });
                bubbleDiv.addEventListener('mouseout', function (e) {
                    let tooltip = {
                        title: '',
                        top: '',
                        left: ''
                    };
                    self.updateTooltip(tooltip);
                });
            }

            el.addEventListener('click', function () { 
                self.triggerEventGA('show_location', {
                    id: feature.properties.id,
                    title: feature.properties.title
                });
                self.onClickMarker(feature.properties.id);
            });

            const marker = self.useMaplibre
            ? new maplibregl.Marker(el).setLngLat(feature.geometry.coordinates).addTo(this.mySmartMap)
            : new mapboxgl.Marker(el).setLngLat(feature.geometry.coordinates).addTo(this.mySmartMap);

            this.locationMarkers.set(feature.properties.id, marker);
        },
        removeLocationMarker(locationId) {
            if (!this.locationMarkers.has(locationId)) return;
            this.locationMarkers.get(locationId).remove();
            this.locationMarkers.delete(locationId);
        },
        removeClusterMarker(clusterId) {
            if (!this.clusterMarkers.has(clusterId)) return;
            this.clusterMarkers.get(clusterId).remove();
            this.clusterMarkers.delete(clusterId);
        },
        hideAllMarkersExcept(id) {
            var markers = document.getElementsByClassName('mapboxgl-marker');
            const markerLength = markers.length;
            for (let i = 0; i < markerLength; i++) {
                const marker = markers[i];
                if (marker.id != `spot-${id}`) {
                    marker.style.display = 'none';
                }
            }
        },
        showAllMarkers() {
            var markers = document.getElementsByClassName('mapboxgl-marker');
            const markerLength = markers.length;
            for (let i = 0; i < markerLength; i++) {
                if (markers[i].id.startsWith('area')) {
                    continue;
                }
                markers[i].style.display = '';
            }
        },
        handleTooltipZoomRange(el) {
            const tooltipBox = el.querySelector('.tooltip-box');
            const markerBox = el.querySelector('.marker-box');
            const bubble = el.querySelector('.bubble');
            const tooltipMarker = el.querySelector('.tooltip-marker');
            const iconMarker = el.querySelector('.icon-marker');

            if (this.currentLocation && 'spot-' + this.currentLocation.properties.id === el.getAttribute('id')) {
                markerBox.style.display = 'block';
                if (tooltipBox && tooltipMarker) {
                    tooltipBox.style.display = 'block';
                    tooltipMarker.style.display = 'block';
                    tooltipBox.style.transform = 'translate(45%, 50%)'
                    if (!bubble) {
                        tooltipBox.style.transform = 'translate(50%, 50%)'
                        markerBox.style.position = 'relative';
                        markerBox.style.bottom = '25px';
                        markerBox.style.transform = 'translate(10%)'
                        if (iconMarker) {
                        iconMarker.classList.add('icon-pin');
                        }
                    }
                }
                return;
            }
            
            const showTooltipBox = this.mySmartMap.getZoom() >= this.mapData.tooltip_zoom;
            const showLocationMarker = this.mySmartMap.getZoom() >= this.mapData.location_zoom_range[0];
        
            tooltipBox.style.display = showTooltipBox ? 'block' : 'none';
            tooltipMarker.style.display = showLocationMarker ? 'none' : 'block';
            markerBox.style.display = showLocationMarker ? 'block' : 'none';
        
            if (showLocationMarker) {
                tooltipBox.style.top = '24px';
                tooltipBox.style.left = '20px';
                if (!bubble) {
                    tooltipBox.style.transform = 'translateX(27%)';
                }
            }
        }
    }
}